import styled from 'styled-components'
import { theme } from '../../../styles/_variables'

export const UploadWrapper = styled.div`
  border: 1px dashed #B8B8B8;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 32px;
  position: relative;
  > input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    opacity: 0;
  }
  > label {
    width: 100%;
    height: 100%;
    text-align: center;
    button {
      padding: 0px 24px;
      background-image: linear-gradient(white, ${theme.color.paleGray});
      > p {
        font-size: 25px;
        color: ${theme.color.lightGrey} !important;
      }
    }
  }
`

export default UploadWrapper



// WEBPACK FOOTER //
// ./src/components/common/upload/styled.js